import axios, {AxiosResponse} from 'axios'
import {AuthModel, UserModel, TwoFactorModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/profile`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/pass/recovery`
export const REQUEST_TWOFACTOR_URL = `${API_URL}/auth/two-factor`

// Server should return AuthModel
export function login(username: string, senha: string) {
  return axios
    .post<AuthModel>(LOGIN_URL, {
      username,
      senha,
    })
    .then((d: AxiosResponse<AuthModel>) => d.data)
}

export function twofactor(code: string) {
  return axios.get<TwoFactorModel>(REQUEST_TWOFACTOR_URL, {params: {code}})
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    nome: `${firstname} ${lastname}`,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{error: string; message: string}>(`${REQUEST_PASSWORD_URL}/${email}`, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}
